module.exports = __webpack_public_path__ + "media/images/plus-circle-29aa6d24d55888958e272b72229df4ee.svg";